import Angular from "angular";
import Controller from "./new-booking-duration.controller";
import Template from "./new-booking-duration.html";

export const NewBookingDurationView = {
    template: Template,
    controller: Controller,
    controllerAs: '$ctrl'
};

export default Angular.module('view.new-booking-duration', []);



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-duration/new-booking-duration.js